import { render, staticRenderFns } from "./OverdueAlertToggle.vue?vue&type=template&id=00b2184c"
import script from "./OverdueAlertToggle.vue?vue&type=script&lang=js"
export * from "./OverdueAlertToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports